import { render, staticRenderFns } from "./file.pug?vue&type=template&id=0bdf9006&lang=pug&external"
import script from "./file.js?vue&type=script&lang=js&external"
export * from "./file.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\selfcare\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bdf9006')) {
      api.createRecord('0bdf9006', component.options)
    } else {
      api.reload('0bdf9006', component.options)
    }
    module.hot.accept("./file.pug?vue&type=template&id=0bdf9006&lang=pug&external", function () {
      api.rerender('0bdf9006', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/input/modules/fileImg/index.vue"
export default component.exports